/* eslint-disable header/header */
export const name = "@azure/msal-react";
export const version = "3.0.19";
